module.exports = __webpack_public_path__ + "static/media/Brace-Yourselves-X-is-Coming.e24bd0e7.jpg";